import {Command, ShapeCommand} from '../commands.template';
import {isExtended} from '../../diagram-render/helpers/shapes-detectors.util';

export class ResourceSwapCommand extends ShapeCommand implements Command {
  protected services;
  private activityMxKey: any;
  private resourceMxKey: any;
  private oldPosition: any;
  private newPosition: any;

  constructor(data) {
    super(data);
    this.activityMxKey = data.activityMxKey;
    this.resourceMxKey = data.resourceMxKey;
    this.oldPosition = data.oldPosition;
    this.newPosition = data.newPosition;
  }

  public execute() {
    super.execute();
    this.services.diagramUpdateSvc.update({
      changeResource: {
        activityMxKey: this.activityMxKey,
        mxKey: this.resourceMxKey,
        position: this.newPosition
      }
    });
    const cell = this.services.registry.getGraph().getModel().getCell(this.activityMxKey);

    if (isExtended(cell)) {
      cell.comp.instance.setupFromJson();
    }
  }

  public reverse() {
    super.reverse();
    this.services.diagramUpdateSvc.update({
      changeResource: {
        activityMxKey: this.activityMxKey,
        mxKey: this.resourceMxKey,
        position: this.oldPosition
      }
    });
    const cell = this.services.registry.getGraph().getModel().getCell(this.activityMxKey);

    if (isExtended(cell)) {
      cell.comp.instance.setupFromJson();
    }
  }
}
